import { useEffect, useState } from 'react'
import type { MapLibreEvent } from 'maplibre-gl'
import { useStore } from '@/store'

export function SearchInViewButton() {
  const filterByBounds = useStore((state) => state.tweets.filterByBounds)
  const setFilterByBounds = useStore((state) => state.setFilterByBounds)
  const map = useStore((state) => state.map.instance)
  const [hidden, setHidden] = useState(false)

  // Reappear when the user moves the map; movestart carries originalEvent
  // only for user gestures (drag, pinch, nav buttons), not programmatic
  // flyTo/easeTo. Scroll zoom fires movestart without originalEvent, so
  // listen for the wheel event separately.
  useEffect(() => {
    if (!map) return

    const handleMoveStart = (e: MapLibreEvent<MouseEvent | TouchEvent | WheelEvent | undefined>) => {
      if (e.originalEvent) setHidden(false)
    }
    const handleWheel = () => setHidden(false)

    map.on('movestart', handleMoveStart)
    map.on('wheel', handleWheel)
    return () => {
      map.off('movestart', handleMoveStart)
      map.off('wheel', handleWheel)
    }
  }, [map])

  // Reappear when the filter is cleared via the "Clear filter" row
  useEffect(() => {
    if (!filterByBounds) setHidden(false)
  }, [filterByBounds])

  // Always (re-)applies the filter for the current view; clearing happens
  // via the "Clear filter" row at the end of the messages list
  const handleClick = () => {
    if (!map) return
    setFilterByBounds(true, map.getBounds())
    setHidden(true)
  }

  if (hidden) return null

  return (
    <button
      type="button"
      className={`search-in-view-btn ${filterByBounds ? 'active' : ''}`}
      onClick={handleClick}
      title={filterByBounds ? 'Update filter to current view' : 'Search messages in view'}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="2" />
        <path d="M11 11L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      Search messages in view
    </button>
  )
}
